export default __webpack_public_path__ + "static/media/Orange Skulls Pattern Halloween Party Poster.fb5adf56.jpg";